// ---------------------------- //
//             Main             //
// ---------------------------- //
// This file is called after every other javascript files

$(document).ready(function () {
    // Vibrant background - avantages
    var $vibrantImgs = $('.vibrant-images');
    $vibrantImgs.waitForImages(function () {
        // All descendant images have loaded, now slide up.
        _.each($vibrantImgs, function (img, key) {
            var imgColorWrapper = $(img).parents('.vibrant-color-container');
            var vibrantLoadImg = function () {
                var vibrant = new Vibrant(img);
                var swatches = vibrant.swatches();
                imgColorWrapper.css('background-color', swatches['DarkVibrant'].getHex());
                img.removeEventListener('load', vibrantLoadImg);
            };
            img.addEventListener('load', vibrantLoadImg);
        });
    });

    // Modules
    window.project.modules.menu = $('.l-header').header();

    window.project.modules.slider = $('.folder-group').folder({
        openFirstFolder: false,
    });

    // Ouvrir le bon dossier si l'ancre dans l'url est un tirroir
    $(function () {
        const urlAnchor = window.location.hash;
        const $anchor = $(urlAnchor);
        if ($anchor.length > 0 && $anchor.hasClass('folder-group')) {
            const $button = $anchor.closest('.folder-group').find('.folder-trigger');
            if ($button.length > 0) {
                $button.trigger('click');
            }
        }
    });

    if ($('.social-widget').length) {
        window.project.modules.socialWidgets = $('.social-widget').socialWidgets();
    }
    window.project.modules.lightbox = $('.lightbox-image').lightbox({
        labels: {
            closeButton: '',
            closeButtonHidden: 'Fermer la lightbox',
        },
        classes: {
            wrapper: 'lightbox-image-wrapper',
        },
    });
    window.project.modules.form = $('.validate-form').customFormValidation();
    window.project.modules.fixedSidebar = $('.actus-social-fixed-wrapper').fixedSidebar();
    window.project.modules.calendar = $('.calendar-full-wrapper').calendar();
    window.project.modules.contentFilters = $('.content-filters').contentFilters();
    window.project.modules.slider = $('.slider').slider({
        displayedSlides: 1,
    });

    // Line animation
    $(function () {
        $('.line-animation-trigger').on('mouseenter', function () {
            $(this).parents('.line-animation-receiver').addClass('is-active');
        });
        $('.line-animation-trigger').on('mouseleave', function () {
            $(this).parents('.line-animation-receiver').removeClass('is-active');
        });
    });

    // Toggle site école - static - to remove
    $(function () {
        $('.toggle-site-ecole').on('click', function () {
            $('body').toggleClass('is-ecole');
        });
    });

    svg4everybody();

    // Ajax loading animation
    $.ajaxSetup({
        beforeSend: $.proxy(function () {
            $('.ajax-loader').addClass('is-active');
        }, this),
        complete: $.proxy(function () {
            $('.ajax-loader').removeClass('is-active');
        }, this),
    });

    // Plax 404
    var layers = $('.js-plaxify');
    if (layers.length !== 0) {
        $.each(layers, function (index, layer) {
            $(layer).plaxify({
                xRange: $(layer).data('xrange') || 0,
                yRange: $(layer).data('yrange') || 0,
                invert: $(layer).data('invert') || false,
            });
        });
    }

    $(function () {
        if ($('#anchorForCalendar').length) {
            $('html, body').animate({
                scrollTop: $('#anchorForCalendar').offset().top,
            }, 2000);
        }
    });

    $(function () {
        $('.custom-video-player').each(function () {
            var $video = $(this).find('video');
            var $button = $(this).find('.btn-play');

            $button.click(function () {
                $video.get(0).play();
            });

            $video.get(0).addEventListener('playing', function () {
                $button.hide();
                $video.removeClass('is-paused');
                $video.get(0).controls = true;
            });

            $video.get(0).addEventListener('pause', function () {
                $button.show();
                $video.addClass('is-paused');
                $video.get(0).controls = false;
            });
        });
    });

    $(function () {
        if ($('.gratitude-list').length > 0) {
            var masonry = new Masonry('.gratitude-list', {
                itemSelector: '.gratitude-item',
                percentPosition: true,
                gutter: 80,
                stagger: 30,
            });
        }
    });

    // set timeout 1s
    setTimeout(function () {
        googleTranslateElementInit();
    }, 1000);
});
